<template>
  <div v-if="!productDescription" class="py-4">
    {{ $t('pdp.product_details_no_info') }}
  </div>
  <div
    v-else
    class="text-md py-4 font-normal leading-5 md:text-lg md:leading-6"
  >
    {{ productDescription }}
  </div>
</template>

<script setup lang="ts">
import type { Product } from '@scayle/storefront-nuxt'

type AttributeValue = string | number | null | undefined

const props = defineProps({
  product: {
    type: Object as PropType<Product | null>,
    default: () => null,
  },
})

const productDescription = computed<AttributeValue>(() => {
  return getProductDescription(props.product)
})
</script>
